export const formatUtrn = (utrn: string) => utrn.replace(/(.{5})(?!$)/g, '$1 ');
